module.exports = __webpack_public_path__ + "media/images/favicon/favicon-01f1e4dbd0384b3bdedb5fa9ebfba7f1.ico";